export const PROJECT_EXPIRATION_PERIOD = 60;